
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/page/[subdomain]/n/[slug]",
      function () {
        return require("private-next-pages/page/[subdomain]/n/[slug].tsx");
      }
    ]);
  